import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const PageLoader = ({ message = 'Loading...', minHeight = '50vh' }) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    minHeight={minHeight}
    role="status"
    aria-live="polite"
  >
    <CircularProgress aria-hidden="true" />
    {message ? (
      <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
        {message}
      </Typography>
    ) : null}
  </Box>
);

export default PageLoader;
